import { Button, Classes, H6 } from '@blueprintjs/core';
import moment from 'moment-timezone';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { CLIENTS, DATE_TIME_FORMAT_24, ERROR_TOAST_ICON, LEVELS, SPECIALITIES, STATES, FROM_TO_DATE_TIME } from '../../../utils/Constants';
import LoadingSpinner from '../../loadingSpinner';
import { getProviders } from '../../services/providerApiService';
import { getTrip, getTrips, getTripsMultiple} from '../../services/tripApiService';
import {formatAlphaNumeric} from '../../../utils/helpers'

import {
    backToTopButton, linkButton,
    dateRangePickerContainer, datesTitleStyle, flexCenter, footerButtonsContainer, tripSearchHeaderContainer, tripSearchHeaderSubcontainer,
    tripSearchContainer, refreshButtonContainer, searchButtonWidth, tripsSpan, popoverContainerDiv, showAdditionalFilters
} from '../../styles';

import { AppToaster } from "../../toastComponent";
import FilterModal, { getFilters, getSpecialtyFilter } from '../modalComponents/filterModal';
import TripsDetailsComponent from '../tripDetails/tripsDetailsComponent';
import TripSearchTable from '../tripSearchView/tripSearchTable';
import AdvancedFilters from './advancedFilters';

const localserviceArea = JSON.parse(localStorage.getItem('serviceAreaCheckboxs'));
const localclientOptions = JSON.parse(localStorage.getItem('clientOptionsCheckboxs'));
const locallevelOptions = JSON.parse(localStorage.getItem('levelOptionsCheckboxs'));
const localspecialtyOptions = JSON.parse(localStorage.getItem('specialtyOptionsCheckboxs'));
const localFromToDateTime = JSON.parse(localStorage.getItem('fromToDateTimeValues'));

export default class TripSearchContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isTripSearchContainer: true,
            trips: [],
            selectedTrip: null,
            selectedRow: null,
            sortBy: 'DueTime',
            sortOrder: 'ASC',
            tripsTop: 100,
            tableRef: React.createRef(),
            filterValues: {
                dueTimeAfterTripLocalTime: moment().toDate(),
                dueTimeBeforeTripLocalTime: moment().toDate(),
                alcPassengerId: '',
                tripNumber: '',
                firstName: '',
                lastName: '',
                serviceProvider: '',
                city: '',
                status: ''
            },
            additionalFilters: false,
            filterModal: false,
            offsetCount: 0,
            isLoading: false,
            serviceAreaCheckboxs: localserviceArea ? localserviceArea : STATES,
            clientOptionsCheckboxs: localclientOptions ? localclientOptions : CLIENTS,
            levelOptionsCheckboxs: locallevelOptions ? locallevelOptions : LEVELS,
            specialtyOptionsCheckboxs: localspecialtyOptions ? localspecialtyOptions : SPECIALITIES,
            fromToDateTimeValues : localFromToDateTime ? localFromToDateTime : FROM_TO_DATE_TIME,
            tripStatusArray: [
                { key: 'Accepted', value: 'Accepted' },
                { key: 'Canceled', value: 'Canceled' },
                { key: 'Complete', value: 'Complete' },
                { key: 'Confirmed', value: 'Confirmed' },
                { key: 'Noload', value: 'Noload' },
                { key: 'Onboard', value: 'Onboard' },
                { key: 'Onsite', value: 'Onsite' },
                { key: 'Open', value: 'Open' },
                { key: 'Void', value: 'Void' }
            ],
            providers: [],
            selectedProviders: []
        };
    }

    componentDidMount = async () => {
        this.props.handleHeaderPathChange("Trip Search");
        await this.getProviders();
    }

    getProviders = async () => {
        try {
            const top = 1000;
            const providers = await getProviders({ top: top });

            this.setState({
                providers: providers
            });
        }
        catch (error) {
            console.log(error);
        }
    }

    handleBackToTopClick = () => {
        this.state.tableRef.current.scrollIntoView({
            block: 'start',
            behavior: 'smooth',
        });
    }

    handleProviderChange = (event) => {
        this.setState({
            selectedProviders: event,
        });
    }

    getProviderIds = () => {
        let providerIds = this.state.selectedProviders.map(provider => provider.provider.providerId);
        return providerIds.join(',');
    }

    validFields() {
        var values = this.state.filterValues;

        if (values.dueTimeAfterTripLocalTime && !values.dueTimeBeforeTripLocalTime) {
            AppToaster.show({ message: 'Please select an end date before searching.', intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });
            return false;
        }

        if (values.dueTimeBeforeTripLocalTime && !values.dueTimeAfterTripLocalTime) {
            AppToaster.show({ message: 'Please select a start date before searching.', intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });
            return false;
        }

        if (!values.dueTimeBeforeTripLocalTime && !values.dueTimeAfterTripLocalTime) {
            AppToaster.show({ message: 'Please select a start and an end date before searching.', intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });
            return false;
        }

        if (!values.status && !values.city && !this.state.selectedProviders && !values.serviceProvider && !values.lastName && !values.firstName && !values.tripNumber && !values.alcPassengerId && !values.dueTimeAfterTripLocalTime && !values.dueTimeBeforeTripLocalTime) {
            AppToaster.show({ message: 'Please search by at least one filter.', intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });
            return false;
        }

        return true;
    }

    handleLoadMore = async () => {
        if (this.state.trips.length <= 1) {
            return;
        }

        var offsetCount = this.state.offsetCount + 1;

        await this.setState({
            isLoadMoreDisabled: true,
            isLoading: true,
        });
        await this.getTrips(offsetCount);
    }


    getTrips = async (offsetCount) => {
        const stateFilter = getFilters(this.state.serviceAreaCheckboxs);
        const clientFilter = getFilters(this.state.clientOptionsCheckboxs);
        const levelFilter = getFilters(this.state.levelOptionsCheckboxs);
        var isVip = getSpecialtyFilter(this.state.specialtyOptionsCheckboxs, "isVip");
        var isOversizeWC = getSpecialtyFilter(this.state.specialtyOptionsCheckboxs, "isOversizeWC");
        var isDialysis = getSpecialtyFilter(this.state.specialtyOptionsCheckboxs, "isDialysis");

        let providerIds = '';
        if (this.state.selectedProviders && this.state.selectedProviders.length > 0) {
            providerIds = this.getProviderIds();
        }

        if (!this.validFields()) {

            this.setState({
                isLoading: false
            });
            return;
        }

        try {
            var optionParams = this.state.filterValues;
            const filterParams = {
                state: stateFilter,
                client: clientFilter,
                serviceLevel: levelFilter,
                isVip: isVip,
                WheelchairType: isOversizeWC,
                dialysis: isDialysis
            }
            const offset = this.state.tripsTop * offsetCount;
            let trips = this.state.trips;
            let newTrips = [];

            if (this.state.additionalFilters) {
                var dueTimeAfterTripLocalTime = moment(optionParams.dueTimeAfterTripLocalTime).startOf('day').format(DATE_TIME_FORMAT_24);
                var dueTimeBeforeTripLocalTime = moment(optionParams.dueTimeBeforeTripLocalTime).endOf('day').format(DATE_TIME_FORMAT_24);

                var params = {
                    top: this.state.tripsTop, offset: offset,
                    SortBy: this.state.sortBy, SortOrder: this.state.sortOrder,
                    PassengerAlcId: optionParams.alcPassengerId,
                    dueTimeBeforeTripLocalTime: dueTimeBeforeTripLocalTime,
                    dueTimeAfterTripLocalTime: dueTimeAfterTripLocalTime,
                    PassengerFirstName: optionParams.firstName,
                    PassengerLastName: optionParams.lastName,
                    serviceProvider: optionParams.serviceProvider,
                    ProviderId: providerIds,
                    PuCity: optionParams.city,
                    status: optionParams.status,
                    state: filterParams.state,
                    client: filterParams.client,
                    serviceLevel: filterParams.serviceLevel,
                    isVip: filterParams.isVip,
                    WheelchairType: filterParams.WheelchairType,
                    dialysis: filterParams.dialysis
                };

                //Removes any empty properties from the optional params
                Object.keys(params).forEach((key) => (params[key] == null || params[key] === '') && delete params[key]);

                newTrips = await getTrips(params);

            } else if (optionParams.tripNumber) {
                newTrips = await getTripsMultiple(optionParams.tripNumber);
            } else {
                var params2 = {
                    top: this.state.tripsTop, offset: offset,
                    SortBy: this.state.sortBy, SortOrder: this.state.sortOrder,
                    state: filterParams.state,
                    client: filterParams.client,
                    serviceLevel: filterParams.serviceLevel,
                    isVip: filterParams.isVip,
                    WheelchairType: filterParams.WheelchairType,
                    dialysis: filterParams.dialysis
                };

                Object.keys(params2).forEach((key) => (params2[key] == null || params2[key] === '') && delete params2[key]);

                newTrips = await getTrips(params2);
            }

            if (newTrips.length === 0) {
                AppToaster.show({ message: 'No trips found.', intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });
                return;
            }

            trips = trips.concat(newTrips);

            this.setState({
                offsetCount: offsetCount,
                trips: trips,
                isLoading: false,
                isLoadMoreDisabled: newTrips.length < this.state.tripsTop ? true : false,
            })
        }

        catch (error) {
            console.log(error);
            let message = 'Unexpected error.';

            if (error.response?.status === 404) {
                message = 'No trip found.';
            }
            AppToaster.show({ message: message, intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });
        }

        finally {
            this.setState({
                isLoading: false,
            })
        }
    }

    handleFilter = async () => {
        this.refreshTrips(this.state.sortBy, this.state.sortOrder);
    }

    refreshTrips = async (sortBy, sortOrder) => {
        await this.setState({
            isLoadMoreVisible: false,
            isLoadMoreDisabled: true,
            offsetCount: 0,
            trips: [],
            selectedTrip: null,
            isLoading: true,
            sortBy: sortBy,
            sortOrder: sortOrder
        });

        this.getTrips(this.state.offsetCount);

    }

    setSelectedTrip = async (e) => {
        try {
            if (e.currentTarget !== this.state.selectedRow) {
                const tripNumber = e.currentTarget.getAttribute('id');
                if (this.state.selectedRow != null) {
                    const selectedRow = this.state.selectedRow;
                    selectedRow.bgColor = '';

                    this.setState({
                        selectedRow: selectedRow,
                    })
                }

                const currentTarget = e.currentTarget;
                currentTarget.bgColor = this.props.themeName === Classes.DARK ? '#00000020' : '#cccccc';

                await this.setState({
                    selectedRow: currentTarget,
                    isLoadingDetails: true,
                    isLoadingKeyEvents: true,
                })

                const trip = await getTrip(tripNumber);

                this.setState({
                    selectedTrip: trip,
                    isLoadingDetails: false
                });
            }
        }
        catch (error) {
            console.log(error);
            let message = 'Unexpected error.';

            if (error.response?.status === 404) {
                message = 'No trip found.';
            }
            AppToaster.show({ message: message, intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });
        }
    }

    //handlers

    handleAdditionalFilters = () => {
        this.setState({
            filterValues: {
                dueTimeAfterTripLocalTime: moment().toDate(),
                dueTimeBeforeTripLocalTime: moment().toDate(),
                alcPassengerId: '',
                tripNumber: '',
                firstName: '',
                lastName: '',
                serviceProvider: '',
                city: '',
                status: ''
            },
            additionalFilters: !this.state.additionalFilters,
            filterModal: false,
            selectedProviders: []
        })
    }

    //Generic input handler
    handleSearchOptionsChange = (e) => {
        var value = e.target.value;
        this.setState({ filterValues: { ...this.state.filterValues, [e.target.name]: formatAlphaNumeric(value) } });
    }

    handleDateRangeChange = (dateRange) => {
        this.setState({
            filterValues: {
                ...this.state.filterValues,
                dueTimeAfterTripLocalTime: dateRange[0],
                dueTimeBeforeTripLocalTime: dateRange[1]
            }
        });
    }

    handleFocus = () => {
        if (this.state.additionalFilters) {
            this.setState({
                additionalFilters: false,filterModal:false})
        } 
    }

    filterOnClick = () => {
        this.setState({
            additionalFilters: false,
            filterModal: !this.state.filterModal,
            filterValues: {
                dueTimeAfterTripLocalTime: moment().toDate(),
                dueTimeBeforeTripLocalTime: moment().toDate(),
                alcPassengerId: '',
                tripNumber: '',
            },
        })
    }

    handleKeySpinner() {
        this.setState({ isLoadingKeyEvents: false });
    }

    handleStatusChange = (event) => {
        this.setState({ filterValues: { ...this.state.filterValues, status: event.target.value } })
    }

    handleFindByTripId = () => {
        if (this.state.filterValues.tripNumber)
            this.refreshTrips(this.state.sortBy, this.state.sortOrder)
        else
            AppToaster.show({ message: 'Trip Number is required.', intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });
    }

    render() {
        var tripsCount = this.state.trips.length;
        var state = this.state;
        return (
            <div style={tripSearchContainer}>
                {this.state.isLoading && <LoadingSpinner />}
                <div style={tripSearchHeaderContainer}>
                    <div style={tripSearchHeaderSubcontainer(this.props.themeName === Classes.DARK)}>
                        <div style={flexCenter}>
                            <span style={tripsSpan}>Trips: {tripsCount}</span>
                            <div style={popoverContainerDiv}>
                                <FilterModal fatherComponent={this} />
                            </div>
                            {!this.state.additionalFilters ?
                                <div style={showAdditionalFilters}>
                                    <span style={linkButton} onClick={this.handleAdditionalFilters}>Show Additional Filters</span>
                                </div>
                                :
                                <div style={showAdditionalFilters}>
                                    <span style={linkButton} onClick={this.handleAdditionalFilters}>Dismiss Additional Filters</span>
                                </div>
                            }
                        </div>
                        <div style={refreshButtonContainer}>
                            <div style={dateRangePickerContainer}>
                                <div style={datesTitleStyle}>
                                    <H6>Trip Number:</H6>
                                </div>
                                <input 
                                    disabled={this.state.additionalFilters || this.state.filterModal} 
                                    className="bp3-input .modifier" name="tripNumber" 
                                    onChange={this.handleSearchOptionsChange}
                                    value={this.state.filterValues.tripNumber}
                                    type="text" 
                                    placeholder="Search..." 
                                    dir="auto" 
                                />
                                    {this.state.additionalFilters &&
                                    <div onClick={this.handleFocus} style={{ position: 'absolute', width: '15%', right: '10%', height: '30px' }}></div>
                                }
                            </div>
                            <Button style={searchButtonWidth} icon="add" disabled={this.state.additionalFilters || this.state.filterModal} text="Search" onClick={this.handleFindByTripId} />
                        </div>
                    </div>
                    {this.state.additionalFilters && (
                        <>
                            <AdvancedFilters
                                values={state.filterValues}
                                themeName={this.props.themeName}
                                handleDateRangeChange={this.handleDateRangeChange}
                                handleSearchOptionsChange={this.handleSearchOptionsChange}
                                filter={() => this.refreshTrips(this.state.sortBy, this.state.sortOrder)}
                                tripStatusArray={this.state.tripStatusArray}
                                tripStatus={this.state.filterValues.status}
                                handleChange={this.handleStatusChange}
                                providers={this.state.providers}
                                selectedProvider={this.state.selectedProvider}
                                handleProviderChange={this.handleProviderChange}
                            />
                        </>
                    )}

                    <div className="container" ref={(ref) => this.scrollParentRef = ref}>
                        <InfiniteScroll
                            loadMore={this.handleLoadMore}
                            hasMore={!this.state.isLoadMoreDisabled}
                            threshold={100}
                            useWindow={true}
                            getScrollParent={() => this.scrollParentRef}
                        >
                            <div className="mt-5 mx-auto" ref={this.state.tableRef}>
                                <TripSearchTable
                                    trips={this.state.trips}
                                    additionalFilters={this.state.additionalFilters}
                                    themeName={this.props.themeName}
                                    setSelectedTrip={this.setSelectedTrip}
                                    selectedTrip={this.state.selectedTrip}
                                    refreshTrips={this.refreshTrips}
                                    customFields={this.state.trips?.customFields}
                                />
                            </div>
                        </InfiniteScroll>
                    </div>
                    {
                        <footer style={footerButtonsContainer}>
                            <Button style={backToTopButton} icon="arrow-up" type="button" onClick={this.handleBackToTopClick} text="Back to top" intent={'primary'} />
                        </footer>
                    }
                </div>
                {
                    this.state.selectedTrip === null ? <div></div> :
                        <TripsDetailsComponent
                            handleKeySpinner={this.handleKeySpinner.bind(this)}
                            selectedTrip={this.state.selectedTrip}
                            isLoadingKeyEvents={this.state.isLoadingKeyEvents}
                            isLoadingDetails={this.state.isLoadingDetails}
                        />
                }
            </div>


        )
    }
}
